export const getDeliveryMethods = async (axios, params) => {
  try {
    return await axios.get('/api/basket/shipping-methods/', params)
  } catch (e) {
    console.error(e)
    throw e
  }
}
